module.exports = __webpack_public_path__ + "img/discard_silo_img2.1d24bed8.jpeg";